<div class="cg3-select-field">
    <div class="cg3-host-text-field">
        <div class="cg3-text-field">
            <div class="cg3-host-form-field">
                <div class="cg3-form-field">
                    @if (label()) {
                        <div class="cg3-host-form-field-header">
                            <div class="cg3-form-field-header cg3-text-field-header">
                                <div class="cg3-host-form-field-label">
                                    <form-field-label-pds3>
                                        <span>{{ label() | wkTranslate }}</span>
                                    </form-field-label-pds3>
                                </div>
                            </div>
                        </div>
                    }

                    <div class="cg3-host-form-field-body">
                        <div class="cg3-form-field-body cg3-text-field-body cg3-form-field-body-{{ size() }}">
                            <div class="cg3-form-field-body-container">
                                <div class="cg3-host-select-field-body">
                                    <div class="cg3-select-field-body" (mouseover)="onHover($event)" (focusin)="onHover($event)">
                                        <kendo-dropdownlist
                                            #dropdownList
                                            [data]="search.filteredData()"
                                            [textField]="textField()"
                                            [valueField]="valueField()"
                                            [value]="displayValue(value)"
                                            [defaultItem]="defaultItem()"
                                            (valueChange)="handleValueChange($event)"
                                            (blur)="onTouched()"
                                            fillMode="none"
                                            rounded="none"
                                            [size]="size()"
                                            [virtual]="
                                                virtual()
                                                    ? {
                                                          itemHeight: 32,
                                                          pageSize: 30,
                                                      }
                                                    : false
                                            "
                                            [listHeight]="256"
                                            [adaptiveMode]="virtual() ? 'none' : 'auto'"
                                            [disabled]="disabled"
                                            [readonly]="readonly"
                                            [valuePrimitive]="valuePrimitive()"
                                            [popupSettings]="{
                                                appendTo: popupAppendTo(),
                                                popupClass: isGroupingEnabled()
                                                    ? 'dropdownlist-wrapper-popup dropdownlist-wrapper-popup--grouped'
                                                    : 'dropdownlist-wrapper-popup',
                                                animate: false,
                                            }"
                                            [tabindex]="disabled ? -1 : 0"
                                            (open)="onBeforeOpen()"
                                            (opened)="onOpen()"
                                            (close)="onClose()"
                                            class="wk-dropdownlist"
                                            closeOnAncestorScroll
                                            [itemDisabled]="onItemDisabled"
                                            [showStickyHeader]="false"
                                        >
                                            @if (isGroupingEnabled()) {
                                                <ng-template kendoDropDownListGroupTemplate let-groupName />
                                            }
                                            @if (search.isFilterable()) {
                                                <ng-template kendoDropDownListHeaderTemplate>
                                                    <wk-dropdown-search-box
                                                        (navigate)="onSearchNavigate($event)"
                                                        (tab)="onSearchTab($event)"
                                                        (focused)="onSearchFocus()"
                                                        (blurred)="onSearchBlur()"
                                                    />
                                                </ng-template>
                                            }
                                            <ng-template kendoDropDownListValueTemplate let-dataItem>
                                                <span class="dropdownlist-wrapper-value" [id]="valueLabelId">
                                                    {{ dataItem | nestedValue: textField() | wkTranslate }}
                                                </span>
                                                @if (isClipped(valueLabelId)) {
                                                    <portal-pds3 elementId="wk-app__root">
                                                        <tooltip-pds3
                                                            mode="description"
                                                            position="top"
                                                            [openDelay]="400"
                                                            [closeDelay]="50"
                                                            [targetSelector]="'#' + valueLabelId"
                                                            flowClass="wk-dropdown-wrapper-tooltip"
                                                        >
                                                            {{ dataItem | nestedValue: textField() | wkTranslate }}
                                                        </tooltip-pds3>
                                                    </portal-pds3>
                                                }
                                            </ng-template>
                                            <ng-template kendoDropDownListItemTemplate let-dataItem>
                                                <div
                                                    class="dropdownlist-wrapper-item"
                                                    [class.disabled-item]="!dataItem || dataItem.disabled"
                                                    [id]="optionLabelId(dataItem)"
                                                >
                                                    @for (
                                                        part of dataItem
                                                            | nestedValue: textField()
                                                            | wkTranslate
                                                            | highlightMatch: search.filterTerm();
                                                        track $index
                                                    ) {
                                                        <span [class.wk-ddlw-highlight]="part.isMatch">{{ part.text }}</span>
                                                    }
                                                </div>
                                                @if (isClipped(optionLabelId(dataItem))) {
                                                    <portal-pds3 elementId="wk-app__root">
                                                        <tooltip-pds3
                                                            mode="description"
                                                            position="top"
                                                            [openDelay]="400"
                                                            [closeDelay]="50"
                                                            [targetSelector]="'#' + optionLabelId(dataItem)"
                                                            flowClass="wk-dropdown-wrapper-tooltip"
                                                        >
                                                            {{ dataItem | nestedValue: textField() | wkTranslate }}
                                                        </tooltip-pds3>
                                                    </portal-pds3>
                                                }
                                            </ng-template>
                                            <ng-template kendoDropDownListNoDataTemplate>
                                                <span class="text-resizing">{{ "SearchBar.NoItemsFound" | wkTranslate }}</span>
                                            </ng-template>
                                        </kendo-dropdownlist>
                                        @if (disabled && tooltipIfDisabled()) {
                                            <portal-pds3 elementId="wk-app__root">
                                                <tooltip-pds3
                                                    mode="description"
                                                    position="top"
                                                    [openDelay]="400"
                                                    [closeDelay]="50"
                                                    [targetSelector]="'#' + hostId"
                                                    flowClass="wk-dropdown-wrapper-tooltip"
                                                >
                                                    {{ tooltipIfDisabled() | wkTranslate }}
                                                </tooltip-pds3>
                                            </portal-pds3>
                                        }

                                        @if (readonly && tooltipIfReadonly()) {
                                            <portal-pds3 elementId="wk-app__root">
                                                <tooltip-pds3
                                                    mode="description"
                                                    position="top"
                                                    [openDelay]="400"
                                                    [closeDelay]="50"
                                                    [targetSelector]="'#' + hostId"
                                                    flowClass="wk-dropdown-wrapper-tooltip"
                                                >
                                                    {{ tooltipIfReadonly() | wkTranslate }}
                                                </tooltip-pds3>
                                            </portal-pds3>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
